import { render, staticRenderFns } from "./buildTeam.vue?vue&type=template&id=791cda3c&scoped=true&"
import script from "./buildTeam.vue?vue&type=script&lang=js&"
export * from "./buildTeam.vue?vue&type=script&lang=js&"
import style0 from "./buildTeam.vue?vue&type=style&index=0&id=791cda3c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791cda3c",
  null
  
)

export default component.exports